import React, {useRef, useState} from 'react';

import {graphql, useStaticQuery} from 'gatsby';
import {Events} from 'src/analytics';
import {BoxProps, Form} from 'src/components/shared';
// Importing Input separately due to strange styled-components bug
import {Typography} from 'src/components/shared/typography';
import {useMarketo} from 'src/hooks/useMarketoForm';
import * as copy from 'src/utils/copy';
import {getMarketoFormElementId, marketoFormIds, munchkinId} from 'src/utils/marketo';
import styled from 'styled-components/macro';

const {P1} = Typography;

const SUBSCRIBE_ID = marketoFormIds.subscribe;
const SUBSCRIBE_FORM_ID = getMarketoFormElementId(SUBSCRIBE_ID);

export type EmailBannerSideBarProps = BoxProps & {
  id: string;
  class: string;
  onSubmit?: VoidFunction;
};

const HiddenMarketoForm = styled.form`
  display: none;
`;

export const EmailBannerSideBar: React.FC<EmailBannerSideBarProps> = ({id, onSubmit, ...props}) => {
  const data = useStaticQuery(graphql`
    query EmailBannerSideBarQuery {
      sanityEmailSignup {
        Heading
        subCopy
      }
    }
  `);

  const emailInputId = `${id}-email-input`;
  const formRef = useRef<HTMLFormElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);

  const [formKey, setFormKey] = useState(Date.now().toString());
  const [showSuccess, setShowSuccess] = useState(false);

  const onFormSubmit = () => {
    setFormKey(Date.now().toString());
    setShowSuccess(true);
    formRef?.current?.reset();
    onSubmit?.();
    return false;
  };

  useMarketo({
    munchkinId,
    formId: SUBSCRIBE_ID,
    formKey,
    callback: form => {
      form.onSuccess(onFormSubmit);
    },
  });

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
    setShowSuccess(false);
    Events.didSubmitForm({page: window?.document?.title, form: 'Newsletter Email Form'});
    const form = window?.MktoForms2?.getForm(SUBSCRIBE_ID);
    form?.setValues({Email: emailRef?.current?.value || ''});
    form?.submit();

    return false;
  };
  const temporary_shouldHideNewsletterSignup = true;

  if (temporary_shouldHideNewsletterSignup) {
    return null;
  }
  return (
    <div className="col-span-full lg:col-span-3 lg:col-start-10" data-module="sidebar-email">
      <div className="bg-beige py-8 px-5">
        <div className="col-span-full type-epsilon">{data.sanityEmailSignup?.Heading}</div>
        <div className="col-span-full flex flex-col md:flex-row lg:flex-col md:items-center xl:items-start">
          <HiddenMarketoForm id={SUBSCRIBE_FORM_ID} />
          <div className="mt-4 sm:mt-0 lg:mt-4 lg:flex w-full md:w-auto flex-col">
            <span className="type-sm-p mt-3 mb-2 block mr-5 text-black">{data.sanityEmailSignup?.subCopy}</span>

            <Form
              ref={formRef}
              id={id}
              onSubmit={handleSubmit}
              className="bg-white text-green-dark rounded-full py-4 px-5 flex justify-between max-w-[320px] newsletter-wrapper"
            >
              <input
                ref={emailRef}
                id={emailInputId}
                name="email"
                type="email"
                placeholder={'email address'}
                className="type-sm-p focus:outline-0 p-0 border-none bg-transparent"
              />
              <button
                type="submit"
                className="type-eyebrow text-green-dark hover:text-black hover:underline hover:decoration-lighter-gray"
              >
                SUBMIT
              </button>
              {showSuccess && (
                <P1 color="lightGreenAriaText" mt="12px">
                  {copy.newsletterForm.successMessage}
                </P1>
              )}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
